/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRequestInformation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13 15h-2v-2h2zM12 4.9c1.296 0 2.078.391 2.533.932.452.537.567 1.204.567 1.728 0 .655-.12 1.086-.323 1.412-.201.323-.48.532-.767.75h-.001c-.573.42-1.045.904-1.16 1.645l-.053.64-.008.093H11.15v-.847l.02-.212c.055-.474.177-.808.35-1.071.195-.298.45-.497.718-.702l.409-.32a3.73 3.73 0 0 0 .376-.354c.226-.25.377-.525.377-.849 0-.368-.177-.658-.442-.86A1.618 1.618 0 0 0 12 6.574c-.45 0-.794.208-1.03.528-.236.322-.364.762-.37 1.216l-.001.099H8.897l.003-.103c.021-.963.282-1.816.8-2.43.519-.617 1.288-.983 2.3-.983z" />
        <path d="M22 2v16H8.499L5.5 22H2V2zM4 4v16h.501L7.5 16H20V4z" />
      </g>
    </g>
  </Icon>
);
export { SvgRequestInformation as RequestInformation };
